module.exports = __webpack_public_path__ + "static/media/service1.c9ba0d28.png";